import React from 'react';
import Hero from './components/Hero/Hero';
import './styles/global.module.css';
import About from './components/About/About';
import Experience from './components/Experience/Experience';
import Project from './components/Projects/Projects';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';




export default function App () {

  return (
    <>
      <Hero />
      <About />
      <Experience />
      <Project />
      <Contact />
      <Footer />
    </>
  )
}